/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import armLogo from '@/assets/microservice.png'

function MicroServiceNode({ data, isConnectable }) {
  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={armLogo} alt="MS Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Micro Services</b>
          </div>
        </div>
      </div>

      <Handle type="target" position={Position.Left} />
      <Handle type="source" position={Position.Left} />
    </div>
  )
}

export default MicroServiceNode
